import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';

export function startDashboardTour() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: { enabled: true },
      classes: 'shepherd-theme-arrows',
      scrollTo: { behavior: 'smooth', block: 'center' },
    },
  });

  tour.addStep({
    id: 'data-inicial',
    title: 'Data Inicial',
    text: 'Selecione aqui a data de início para buscar os dados.',
    attachTo: {
      element: '#initial-date',
      on: 'bottom',
    },
    buttons: [{ text: 'Próximo', action: tour.next }],
  });

  tour.addStep({
    id: 'data-final',
    title: 'Data Final',
    text: 'Defina a data final do período da busca.',
    attachTo: {
      element: '#final-date',
      on: 'bottom',
    },
    buttons: [{ text: 'Próximo', action: tour.next }],
  });


  tour.addStep({
    id: 'botao-buscar',
    title: 'Botão Buscar',
    text: 'Clique aqui para executar a busca conforme as datas selecionadas.',
    attachTo: {
      element: 'button.btn-primary',
      on: 'bottom',
    },
    buttons: [{ text: 'Próximo', action: tour.next }],
  });

  tour.addStep({
    id: 'botao-enviar',
    title: 'Envio manual dos arquivos',
    text: 'Clique aqui para enviar os arquivos de conciliação manualmente',
    attachTo: {
      element: '#btn-enviar',
      on: 'bottom',
    },
    buttons: [{ text: 'Próximo', action: tour.next }],
  });

  tour.addStep({
    id: 'recibos',
    title: 'Recibos',
    text: 'Aqui está um resumo, com os valores brutos e não conciliados, quando houver.',
    attachTo: {
      element: '#receipt-area',
      on: 'top',
    },
    buttons: [{ text: 'Próximo', action: tour.next }],
  });

  tour.addStep({
    id: 'reconciliar-valores',
    title: 'Reconciliar Valores',
    text: 'Clique aqui para reconciliar os valores.',
    attachTo: {
      element: '#btn-reconciliar',
      on: 'right',
    },
    buttons: [{ text: 'Próximo', action: tour.next }],
  });

  tour.addStep({
    id: 'exportar-relatorios',
    title: 'Exportar Relatórios',
    text: 'Clique aqui para exportar os dados em forma de planilha.',
    attachTo: {
      element: '#btn-excel',
      on: 'right',
    },
    buttons: [{ text: 'Próximo', action: tour.next }],
  });

  tour.addStep({
    id: 'sumario',
    title: 'Sumário',
    text: 'Aqui são exibidos os valores brutos gerais.', 
    attachTo: {
      element: '#summary',
      on: 'right',
    },
    buttons: [{ text: 'Próximo', action: tour.next }],
  });

tour.addStep({
  id: 'tabela-detalhada',
  title: 'Tabela Detalhada',
  text: 'Aqui é exibida a tabela com ou sem dados.',
  attachTo: {
    element: '#noData-table',
    on: 'bottom',
  },
  buttons: [
    {
      text: 'Finalizar',
      action: tour.complete,
      classes: 'shepherd-button shepherd-button-finish',
    },
  ],
});

tour.start();
}
